import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

/**
 * A default error boundary component that navigates to an error page.
 *
 * @param {Object} props - The properties object.
 * @param {Record<string, string>} props.userData - The user data to include in the URL search parameters.
 * @param {URLSearchParams} searchParams - The current URL search parameters.
 * @returns {ReactNode} A Navigate component that redirects to the error page with appropriate search parameters.
 */
export const defaultErrorBoundary = (
  { userData }: { userData: Record<string, string> },
  searchParams: URLSearchParams
): ReactNode => {
  if (searchParams.size === 0) {
    return <Navigate to={{ pathname: "/error", search: new URLSearchParams(userData).toString() }} />;
  }
  return <Navigate to={{ pathname: "/error", search: searchParams.toString() }} />;
};
